// ============================================================================
// ENGAGEMENT TYPE ENDPOINTS
// ============================================================================
// URL builders for the EngagementType master.
//
// Backend project:    prima-app/prima-api
// Backend controller: prima.Api/Controllers/MasterModule/EngagementTypesController.cs
// Verified route:     [Route("api/v1/[controller]")]  →  /api/v1/EngagementTypes
//
// BASE_PATH MUST match the controller class name (minus "Controller" suffix)
// EXACTLY — PascalCase plural, no kebab-case (the API does NOT use
// SlugifyParameterTransformer).

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/EngagementTypes';

export const engagementTypeEndpoints = {
  /** GET /api/v1/EngagementTypes — paginated list with filters */
  list: () => buildEndpoint(BASE_PATH),

  /** GET /api/v1/EngagementTypes/{id} */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** GET /api/v1/EngagementTypes/code/{code} */
  getByCode: (code: string) =>
    buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),

  /** POST /api/v1/EngagementTypes */
  create: () => buildEndpoint(BASE_PATH),

  /** PUT /api/v1/EngagementTypes/{id} */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** DELETE /api/v1/EngagementTypes/{id} → 204 No Content on success */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Raw path (NOT version-prefixed) — for use with buildEndpointWithQuery,
   * which adds the version prefix internally. Passing the result of
   * buildEndpoint() to buildEndpointWithQuery causes a doubled `/v1/v1/...`.
   */
  basePath: () => BASE_PATH,
} as const;

export default engagementTypeEndpoints;
